import Vue from "vue";
import VueRouter from "vue-router";

const pageApp = r => require.ensure([], () => r(require('../pages/app.vue')), 'page-app');
const pageHome = r => require.ensure([], () => r(require('../pages/home.vue')), 'page-home');
const pageActivity = r => require.ensure([], () => r(require('../pages/activity.vue')), 'page-activity');
const pageDonate = r => require.ensure([], () => r(require('../pages/donate.vue')), 'page-donate');
const pageOrganization = r => require.ensure([], () => r(require('../pages/organization.vue')), 'page-organization');
const pageAlist = r => require.ensure([], () => r(require('../pages/article/list.vue')), 'page-alist');
const pageAdetail = r => require.ensure([], () => r(require('../pages/article/detail.vue')), 'page-adetail');
const pageClist = r => require.ensure([], () => r(require('../pages/content/list.vue')), 'page-clist');
const pageCdetail = r => require.ensure([], () => r(require('../pages/content/detail.vue')), 'page-cdetail');
const page404 = r => require.ensure([], () => r(require('../pages/404.vue')), 'page-404');

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [{
    path: '/',
    component: pageApp,
    children: [
      {
        path: '',
        redirect: '/home'
      },
      {
        path: '/home',
        component: pageHome
      },
      {
        path: '/activity',
        component: pageActivity
      },
      {
        path: '/donate',

        component: pageDonate,
      }, {
        path: '/organization',
        component: pageOrganization,
      }, {
        path: '/alist',
        component: pageAlist,
      }, {
        path: '/adetail',
        component: pageAdetail,
      }, {
        path: '/clist',
        component: pageClist,
      }, {
        path: '/cdetail',
        component: pageCdetail,
      },
      {
        path: '*',
        component: page404
      }]
  }]
});
module.exports = router;



// WEBPACK FOOTER //
// ./src/routers/index.js